import { FC } from 'react';
import cx from 'classnames';

import { IconProps } from './type';

export const ArrowLeft: FC<IconProps> = ({ className }) => (
  <svg
    viewBox="0 0 30 30"
    xmlns="http://www.w3.org/2000/svg"
    className={cx(className, ' fill-current')}
  >
    <path d="M17.268 20.793a.75.75 0 0 1-1.06-.026l-5.002-5.25a.75.75 0 0 1 0-1.035l5.001-5.25a.75.75 0 1 1 1.086 1.034L12.785 15l4.508 4.734a.75.75 0 0 1-.025 1.06z" />
  </svg>
);
